import React from "react";
import img2 from "../../../assets/img10.jpg";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock } from "react-icons/fa";
import { motion } from "framer-motion"; // Import Framer Motion

const Kontaktmain = () => {
  return (
    <div className="container mx-auto bg-black">
      {/* Section with Background Image */}
      <div
        className="relative bg-cover bg-center pt-[150px] pb-[50px]"
        style={{
          backgroundImage: `url(${img2})`,
        }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>{" "}
        {/* Dark overlay */}
        <h1 className="text-5xl font-semibold text-center mb-8 text-white uppercase relative">
          Kontakt
        </h1>
      </div>

      {/* Main Content Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 bg-[#191919] px-6 py-[50px]">
        {/* Left Side: Google Map */}
        <motion.div
          className="w-full"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, type: "spring", stiffness: 100 }}
        >
          <iframe
            src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=Manufaktura Formy Białystok, Górka Tomka 6ZC, 15-521 Zaścianki&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            width="100%"
            height="550"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </motion.div>

        {/* Right Side: Contact Form and Information */}
        <div className="flex flex-col space-y-6">
          {/* Contact Form */}
          <motion.form
            className="bg-white p-6 rounded-lg shadow-md space-y-6"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
            {" "}
            {/* Title */}
            <motion.h1
              className="text-5xl font-semibold uppercase text-[#323232]"
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.2 }}
            >
              Skontaktuj się z nami
            </motion.h1>
            <div>
              <label
                className="block text-[#323232] text-lg font-semibold mb-2"
                htmlFor="name"
              >
                Imię
              </label>
              <input
                type="text"
                id="name"
                className="w-full p-3 border border-gray-300 rounded-md"
                placeholder="Wpisz swoje imię"
              />
            </div>
            <div>
              <label
                className="block text-[#323232] text-lg font-semibold mb-2"
                htmlFor="email"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                className="w-full p-3 border border-gray-300 rounded-md"
                placeholder="Wpisz swój email"
              />
            </div>
            <div>
              <label
                className="block text-[#323232] text-lg font-semibold mb-2"
                htmlFor="message"
              >
                Wiadomość
              </label>
              <textarea
                id="message"
                className="w-full p-3 border border-gray-300 rounded-md"
                placeholder="Napisz swoją wiadomość"
                rows="4"
              ></textarea>
            </div>
            {/* Submit Button */}
            <motion.div
              className="flex justify-center"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.2 }}
            >
              <button
                type="submit"
                className="px-6 py-2 bg-orange-500 text-black font-semibold rounded-lg hover:bg-orange-700"
              >
                Wyślij
              </button>
            </motion.div>
          </motion.form>
        </div>
      </div>

      {/* Contact Information */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 px-4 py-10 bg-[#191919]">
        {/* Phone */}
        <motion.div
          className="flex items-center space-x-4 bg-white p-4 rounded-lg shadow-md"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <FaPhone className="text-3xl text-orange-500" />
          <div>
            <h3 className="font-semibold text-[#323232]">Telefon</h3>
            <p className="text-[#323232]">+48 1111 111 111</p>
          </div>
        </motion.div>

        {/* Email */}
        <motion.div
          className="flex items-center space-x-4 bg-white p-4 rounded-lg shadow-md"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.6 }}
        >
          <FaEnvelope className="text-3xl text-orange-500" />
          <div>
            <h3 className="font-semibold text-[#323232]">Email</h3>
            <p className="text-[#323232]">
              <a href="test@gmail.com" className="text-orange-500">
                test@gmail.com
              </a>
            </p>
          </div>
        </motion.div>

        {/* Address */}
        <motion.div
          className="flex items-center space-x-4 bg-white p-4 rounded-lg shadow-md"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.7 }}
        >
          <FaMapMarkerAlt className="text-3xl text-orange-500" />
          <div>
            <h3 className="font-semibold text-[#323232]">Adres</h3>
            <p className="text-[#323232]">adres, Polska</p>
          </div>
        </motion.div>

        {/* Working Hours */}
        <motion.div
          className="flex items-center space-x-4 bg-white p-4 rounded-lg shadow-md"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          <FaClock className="text-3xl text-orange-500" />
          <div>
            <h3 className="font-semibold text-[#323232]">Godziny Otwarcia</h3>
            <p className="text-[#323232]">Pon - Pią: 6:30 - 22:00</p>
            <p className="text-[#323232]">Sobota: 7:00 - 15:00</p>

            <p className="text-[#323232]">Recepcja: 15:30 - 20:30</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Kontaktmain;
